import React from "react";
import styles from "../../FilePreviewModal.module.scss";

interface PDFPreviewProps {
  url: string;
}

const PDFPreview: React.FC<PDFPreviewProps> = ({ url }) => {


  return (
    <div className={`${styles.pdfContainer}`}>
      {/* Simple toolbar */}
      
      {/* Basic PDF Viewer using iframe */}
      <div className={`w-full h-full ${styles.pdfWrapper}`}>
        <iframe
         src={`${url}#toolbar=1&view=Fit&navpanes=1&scrollbar=1`}
          className={styles.pdfIframe}
          title="PDF Preview"
          frameBorder="0"
        />
      </div>
    </div>
  );
};

export default PDFPreview;
